import { Model } from './Model';

export const Size = Model('Size', {
    endpoint: 'apparel-sizes',
})`
    id:Int;
    name:String;
    alias:String;
    code:String;
`;
